export enum TiffStatusEnum {
  uploading = 'uploading',
  uploaded = 'uploaded',
  processing = 'processing',
  error = 'error',
  processed = 'processed',
  publishing = 'publishing',
  confirm = 'confirm'
}
